import { Box, Link } from "@mui/material";
import FacebookIcon from "@mui/icons-material/Facebook";
import InstagramIcon from "@mui/icons-material/Instagram";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import {
  FooterInnerContainer,
  FooterOmmuseRights,
  RightSideFooter,
  styles,
} from "./styles";

const Footer: React.FC = () => {
  return (
    <Box sx={styles.footerContainer}>
      <FooterInnerContainer>
        <Box sx={styles.leftSideFooter}>
          <Box>
            <div style={{ height: "15px" }}></div>
            <Link
              sx={styles.footerHeader}
              target="_blank"
              href={`${window.location.origin}/terms-of-use`}
            >
              Terms of Use
            </Link>
            <div style={{ height: "15px" }}></div>
            <Link
              sx={styles.footerHeader}
              target="_blank"
              href={`${window.location.origin}/enterprise-addendum`}
            >
              Enterprise Addendum
            </Link>
            <div style={{ height: "15px" }}></div>
            <Link
              sx={styles.footerHeader}
              target="_blank"
              href={`${window.location.origin}/privacy-policy`}
            >
              Privacy Policy
            </Link>
            <div style={{ height: "15px" }}></div>
            <Link sx={styles.footerHeader} href="mailto:hello@ommuse.com">
              hello@ommuse.com
            </Link>
            <div style={{ height: "15px" }}></div>
            <Link
              sx={styles.footerHeader}
              target="_blank"
              href="https://www.facebook.com/groups/ommuse"
            >
              Join The Facebook Group
            </Link>
          </Box>
        </Box>
        <RightSideFooter>
          <Box>
            <Link target="_blank" href="https://www.facebook.com/ommuse.music">
              <FacebookIcon style={styles.icon} />
            </Link>
            <Link
              target="_blank"
              href="https://www.instagram.com/ommuse.music/"
            >
              <InstagramIcon style={styles.icon} />
            </Link>
            <Link
              target="_blank"
              href="https://www.linkedin.com/company/ommuse/"
            >
              <LinkedInIcon style={styles.icon} />
            </Link>
          </Box>
        </RightSideFooter>
      </FooterInnerContainer>
      <FooterOmmuseRights>
        <p style={styles.footerRights}>© 2023 OmMuse. All rights reserved</p>
      </FooterOmmuseRights>
    </Box>
  );
};

export default Footer;
